import {
	TableContainer,
	Table,
	TableHead,
	TableBody,
	TableRow,
	TableCell,
	useTheme,
	useMediaQuery,
	Skeleton,
	Grid,
	Card,
	CardContent,
} from '@mui/material';
import { useParams } from 'react-router-dom';
import { CerebroBreadcrumb, CerebroLabel, CerebroPageContainer, CerebroText } from '../../shared/components';
import { useDataRoomTeasersQuery } from '../../shared/hooks';
import { EnumUtils } from '../../shared/utils';

export const CompanyTeasersPage: React.FC = () => {
	const theme = useTheme();
	const { guid } = useParams<'guid'>();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));

	const teasersQuery = useDataRoomTeasersQuery(guid);

	return (
		<CerebroPageContainer maxWidth={'100%'}>
			<CerebroBreadcrumb>Teasers</CerebroBreadcrumb>

			{isMobile ? (
				<Grid container spacing={2} alignItems="stretch">
					{teasersQuery.isLoading && (
						<>
							<Skeleton height={125} />
							<Skeleton height={125} />
							<Skeleton height={125} />
						</>
					)}

					{teasersQuery.data?.teasers
						.filter(teaser => !teaser.isDeleted)
						.map(teaser => {
							return (
								<Grid key={teaser.guid} item xs={12}>
									<Card
										key={teaser.guid}
										elevation={3}
										sx={{
											display: 'flex',
											justifyContent: 'space-between',
											flexDirection: 'column',
											height: '100%',
											marginBottom: 2,
										}}
									>
										<CardContent sx={{ paddingBottom: '0 !important' }}>
											<Grid container sx={{ marginBottom: 2 }}>
												<Grid item xs={8} sx={{ display: 'flex' }}>
													<CerebroLabel sx={{ fontWeight: 'bold', alignSelf: 'center' }}>
														{teaser.bankName}
													</CerebroLabel>
												</Grid>
												<Grid item xs={4} sx={{ textAlign: 'right' }}>
													{EnumUtils.GetTeaserDecisionStatusDescription(
														teaser.decisionStatus
													)}
												</Grid>
											</Grid>
											<CerebroText gutterBottom sx={{ marginTop: 1 }}>
												{EnumUtils.GetTier1BankTypeDescription(teaser.tier1Type)}
											</CerebroText>
											<CerebroText gutterBottom sx={{ marginTop: 1 }}>
												{EnumUtils.GetStructureTrancheDescription(teaser.structureType)}
											</CerebroText>
										</CardContent>
									</Card>
								</Grid>
							);
						})}
				</Grid>
			) : (
				<TableContainer>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>Lender</TableCell>
								<TableCell>Lender Type</TableCell>
								<TableCell>Tranche</TableCell>
								<TableCell>Status</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{teasersQuery.isLoading && (
								<>
									<TableRow>
										<TableCell colSpan={4}>
											<Skeleton height={60} />
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell colSpan={4}>
											<Skeleton height={60} />
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell colSpan={4}>
											<Skeleton height={60} />
										</TableCell>
									</TableRow>
								</>
							)}
							{teasersQuery.isSuccess && (
								<>
									{teasersQuery.data.teasers
										.filter(
											teaser => !teaser.isDeleted && (!teaser.ignoreAtLaunch || teaser.sentOn)
										)
										.map(teaser => {
											return (
												<TableRow key={teaser.guid}>
													<TableCell>{teaser.bankName}</TableCell>
													<TableCell>
														{EnumUtils.GetTier1BankTypeDescription(teaser.tier1Type)}
													</TableCell>
													<TableCell>
														{EnumUtils.GetStructureTrancheDescription(teaser.structureType)}
													</TableCell>
													<TableCell>
														{EnumUtils.GetTeaserDecisionStatusDescription(
															teaser.decisionStatus
														)}
													</TableCell>
												</TableRow>
											);
										})}
									{teasersQuery.data.teasers.length == 0 && (
										<TableRow>
											<TableCell colSpan={4} sx={{ textAlign: 'center' }}>
												<CerebroText>
													No teasers have been sent to any lenders at this time.
												</CerebroText>
											</TableCell>
										</TableRow>
									)}
								</>
							)}
						</TableBody>
					</Table>
				</TableContainer>
			)}
		</CerebroPageContainer>
	);
};
